// extracted by mini-css-extract-plugin
module.exports = {"video-player-container":"playVideo_video-player-container__3K2vd","video-player":"playVideo_video-player__palGi"};